<template>
  <div class="loginVerification">
    <div class="top-bg">
      <img src="@/assets/images/home/login-verification-bg.png" alt="">
    </div>
    <!-- 内容区域 -->
    <div class="content">
      <div class="title">温馨提示</div>
      <div class="message">
        抱歉，您访问的链接已失效，请通过iEP首页进行搜索查看。
      </div>

      <img src="@/assets/images/person/memberType1.png" alt="" class="tip-img">

      <!-- 按钮区域 -->
      <div class="button-group">
        <van-button
          class="modify-btn"
          @click="handleGoHome"
          v-track="{ functionName: '链接失效-点击访问首页' }"
        >
          点击访问首页
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import withRouteTracking from '@/utils/withRouteTracking'

const LinkExpired = {
  name: 'LinkExpired',
  methods: {
    handleGoHome() {
      localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/home`)
      this.$router.replace('/home')
    }
  }
}

export default withRouteTracking(LinkExpired)
</script>

<style scoped lang="less">
.loginVerification {
  position: relative;
  width: 100%;
  height: 100vh;
  padding: 48px 12px 0;
  box-sizing: border-box;

  .top-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;

    img {
      width: 100%;
    }
  }

  .content {
    position: relative;
    padding: 24px;
    background: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      font-size: 24px;
      font-weight: 600;
      color: #181818;
      text-align: center;
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translateX(-50%);
      font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
    }

    .message {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      margin-bottom: 20px;
      white-space: pre-line;
      line-height: 25px;
    }

    .tip-img {
      width: 160px;
    }
  }
}

.button-group {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 16px;
  width: 100%;
  padding: 0 24px;
}

.modify-btn {
  border-radius: 22px;
  font-size: 16px;
  font-weight: 500;
  width: 100%;
  height: 42px;
  background: #EB1700;
  font-family: PingFang SC, PingFang SC;
  color: #FFFFFF;
  cursor: pointer;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/loginPage/linkExpired.vue